import ContentImage from './ContentImage';

export default ContentImage;
